import { OriginsType } from './config.types';

export const ServiceOrigins: { [key: string]: OriginsType } = {
  LOCAL_SM: {
    TAGGING: 'http://localhost:9090/tagging',
    SM: 'http://localhost:9090/api/v1',
    MW: 'http://localhost:9090/maintenance-window',
    KYC: 'http://localhost:9090/kyc/api',
    BILLING: 'http://localhost:9090/billing',
    TGW: 'http://localhost:9090/cloud-transit-gateway',
    PRIVATE_LINK: 'http://localhost:9090/cloud-resource-link',
    DATABASE: 'http://localhost:9090/cloud-db-service',
    DATABASE_ENDPOINTS: 'http://localhost:9090/cloud-db-endpoints-service',
    METRICS: 'http://localhost:9090/v1',
    AI: 'http://localhost:9090/ai'
  },
  TEST: {
    TAGGING: 'http://localhost',
    SM: 'http://localhost',
    MW: 'http://localhost',
    KYC: 'http://localhost',
    BILLING: 'http://localhost',
    TGW: 'http://localhost',
    PRIVATE_LINK: 'http://localhost',
    DATABASE: 'http://localhost',
    DATABASE_ENDPOINTS: 'http://localhost',
    METRICS: 'http://localhost',
    AI: 'http://localhost'
  }
} as const;
